/* src/app/dashboard/rank/guru-badge-dialog/guru-badge-dialog.component.scss */
.guru-dialog-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-top: 16px;
}
.guru-dialog-badge {
  width: 120px;
  height: 120px;
  object-fit: contain;
  margin-bottom: 8px;
}
.guru-dialog-title {
  margin: 0 0 8px;
}
.guru-dialog-body {
  margin: 0;
}
.guru-dialog-actions {
  gap: 8px;
  padding: 8px 24px 16px;
}
/*# sourceMappingURL=guru-badge-dialog.component.css.map */
